<div class="row">
  <div class="col-12">
    <h3 id="propertyTransferredNonShareConsideration">Contrepartie autre qu'en actions</h3>

    <magieno-boolean-select
    [advancedFormControl]="this.isCalculateMaximumNonShareConsideration"></magieno-boolean-select>

    @if (propertyForm.value.isCalculateMaximumNonShareConsideration) {
      <div class="alert alert-light" role="alert">
        <i class="fas fa-exclamation-triangle"></i>Veuillez indiquer la valeur minimum que vous voulez attribuer à
        une
        contrepartie autre qu’en actions spécifique s’il y a lieu.
        L’excédent de la CAA maximale sur la valeur minimum attribué sera réparti automatiquement au « Billet à
        payer »
      </div>
    }

    <table class="table mt-5 mb-2">
      <thead class="table-light">
        <tr>
          <th>Identifiant de la contrepartie</th>
          <th>Contrepartie autre qu'en actions</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        @for (propertyTransferredNonShareConsideration of this.nonShareConsiderations.formGroups; track propertyTransferredNonShareConsideration; let i = $index) {
          <tr>
            <td>
              <magieno-dynamic-select
                [advancedFormControl]="this.getNonShareConsiderationId(propertyTransferredNonShareConsideration)"
                [items]="this.nonShareConsiderationsSelectKeyValues"
              [showTitle]="false"></magieno-dynamic-select>
            </td>
            <td>
              <magieno-input-money-field
                [advancedFormControl]="this.getAmountOfNonShareConsideration(propertyTransferredNonShareConsideration)"
                [currency]="this.currency"
                [locale]="this.locale"
              [showTitle]="false"></magieno-input-money-field>
            </td>
            <td>
              <div class="dropdown d-flex" style="width: fit-content">
                <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                  data-expanded="false" href="#" role="button">
                  <i class="fe fe-more-vertical"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a (click)="removePropertyTransferredNonShareConsideration(propertyForm, i); $event.preventDefault()"
                    class="dropdown-item"
                    href="#">
                    Supprimer
                  </a>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <a (click)="this.addPropertyTransferredNonShareConsideration();$event.preventDefault()"
      [id]="'property_transferred_' + propertyTransferredIndex + '_add_non_share_consideration'"
      class="btn btn-primary ms-3"
      href="#propertyTransferredNonShareConsideration">
      + Ajouter une contrepartie autre qu'en actions
    </a>

    <button (click)="addNonShareConsiderationType()"
      [id]="'property_transferred_' + propertyTransferredIndex + '_add_non_share_consideration_type'"
      class="btn btn-light btn-small ms-2">Créer un nouveau type de
      contrepartie
    </button>

  </div>
</div>